import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { TransactionSearch } from './TransactionSearch';
import { TransactionDisplay } from './TransactionDisplay';
import { TransRowSearch } from './TransRowSearch';

export const TransactionRoutes: React.FC = () => (
  <Routes>
    <Route path="/search-row" element={<TransRowSearch />} />
    <Route path="/search" element={<TransactionSearch />} />
    <Route path="/display/:key" element={<TransactionDisplay />} />
  </Routes>
);
